"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductUnitSchema = exports.ConversationalInformationDiscoveryWidgetSchema = exports.SectionDividerSchema = exports.SectionGroupHeaderSchema = exports.RelatedKeywordSchema = exports.OmBannerSchema = exports.ImageBannerSchema = void 0;
var zod_1 = require("zod");
var badge_1 = require("../common/badge");
var PriceSchema = zod_1.z.object({
    discountRate: zod_1.z.string().nullish(),
    originPrice: zod_1.z.string().nullish(),
    discountPrice: zod_1.z.string().nullish(),
    discountPriceUnit: zod_1.z.string().nullish(),
    dailyPrice: zod_1.z.string().nullish(),
    longTermDays: zod_1.z.string().nullish(),
    infoText: zod_1.z.string().nullish(),
    priceBadge: zod_1.z.string().nullish(),
    originPriceNote: zod_1.z.string().nullish(),
    closedInformation: zod_1.z.string().nullish(),
    couponText: zod_1.z.string().nullish(),
});
var MarkerSchema = zod_1.z.object({
    position: zod_1.z.object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
    }),
    title: zod_1.z.string(),
    disabled: zod_1.z.boolean(),
});
var ReviewSchema = zod_1.z.object({
    noScoreText: zod_1.z.string().nullish(),
    score: zod_1.z.string(),
    count: zod_1.z.string(),
});
var ActionSchema = zod_1.z.object({
    app: zod_1.z.string(),
    web: zod_1.z.string(),
});
exports.ImageBannerSchema = zod_1.z.object({
    type: zod_1.z.literal('IMAGE_BANNER'),
    data: zod_1.z.object({
        title: zod_1.z.string(),
        thumbnail: zod_1.z.string(),
        fallbackThumbnail: zod_1.z.string().nullish(),
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.OmBannerSchema = zod_1.z.object({
    type: zod_1.z.literal('ONSITE_MARKETING_BANNER'),
    data: zod_1.z.object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string().nullish(),
        buttonText: zod_1.z.string(),
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string(),
        }),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.RelatedKeywordSchema = zod_1.z.object({
    type: zod_1.z.literal('RELATED_KEYWORD'),
    data: zod_1.z.object({
        title: zod_1.z.string(),
        items: zod_1.z.array(zod_1.z.string()),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.SectionGroupHeaderSchema = zod_1.z.object({
    type: zod_1.z.literal('SECTION_GROUP_HEADER'),
    data: zod_1.z.object({
        title: zod_1.z.string().nullish(),
        tooltip: zod_1.z.string().nullish(),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.SectionDividerSchema = zod_1.z.object({
    type: zod_1.z.literal('SECTION_DIVIDER'),
});
exports.ConversationalInformationDiscoveryWidgetSchema = zod_1.z.object({
    type: zod_1.z.literal('CONVERSATIONAL_INFORMATION_DISCOVERY_WIDGET'),
    data: zod_1.z.object({
        header: zod_1.z.object({
            title: zod_1.z.string(),
            subTitle: zod_1.z.string(),
            icon: zod_1.z.string(),
            more: zod_1.z.object({
                title: zod_1.z.string(),
                action: ActionSchema,
                serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
            }),
        }),
        items: zod_1.z.array(zod_1.z.object({
            title: zod_1.z.string(),
            action: ActionSchema,
            serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
        })),
    }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
/**
 * srp / plp 상품 아이템 타입
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/~jusong.lee/pages/491947083/PLP+SRP#Interface}
 * */
exports.ProductUnitSchema = zod_1.z.object({
    type: zod_1.z.enum(['PRODUCT_ITEM', 'BANNER_TYPE_PRODUCT_ITEM', 'CARD_TYPE_PRODUCT_ITEM']),
    data: zod_1.z.object({
        id: zod_1.z.string(),
        action: ActionSchema,
        thumbnail: zod_1.z.string(),
        fallbackThumbnail: zod_1.z.string().nullish(),
        thumbnailBadges: zod_1.z.array(badge_1.BadgeSchema).nullish(),
        newRegistered: zod_1.z.string().nullish(),
        category: zod_1.z.string().nullish(),
        title: zod_1.z.string(),
        dateInfo: zod_1.z.string().nullish(),
        locationInfo: zod_1.z.string().nullish().optional(),
        locationDetails: zod_1.z.array(zod_1.z.string()).nullish(),
        review: ReviewSchema.nullish(),
        benefitBadges: zod_1.z.array(badge_1.BadgeSchema).nullish(),
        prices: zod_1.z.array(PriceSchema),
        features: zod_1.z.array(zod_1.z.string()).nullish(),
        descriptions: zod_1.z.array(zod_1.z.string()).nullish(),
        adText: zod_1.z.string().nullish(),
        aiMotionImage: zod_1.z
            .object({
            videoUrl: zod_1.z.string(),
            thumbnailUrl: zod_1.z.string(),
        })
            .nullish(),
        bannerBottomSheet: zod_1.z
            .object({
            title: zod_1.z.string(),
            imageUrl: zod_1.z.string(),
            buttonText: zod_1.z.string(),
            action: zod_1.z.object({
                app: zod_1.z.string(),
                web: zod_1.z.string(),
            }),
            serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
        })
            .nullish(),
    }),
    marker: MarkerSchema.nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
